import { SupportTokenAction as o } from "../../constants/config.js";
import { currencyTokenTypeERC20Schema as r, currencyTokenAssetNameSchema as n } from "../../../currency-lib/deserialize/yup/currency.js";
import { conjunctItemSchema as s } from "../../../planet-lib/deserializes/yup/conjunct.js";
import * as a from "ramda";
import * as e from "yup";
const f = e.object({
  age: e.number().default(0),
  slot_count: e.number().default(0)
}).noUnknown(!0), u = e.object({
  currencyCode: r,
  assetName: n,
  amount: e.number().default(0)
}).from("currency_code", "currencyCode").from("asset_name", "assetName"), i = e.object({
  consumeApostleMax: e.number().default(0)
}).from("consume_apostle_max", "consumeApostleMax").noUnknown(!0), p = e.object({
  cooldown: e.number().default(0)
}).noUnknown(!0), _ = e.object({
  cooldown: e.number().default(0),
  max: e.number().default(5),
  breedCost: e.array().of(e.array().of(s)).default([]),
  breedCostTable: e.object()
}).from("max_count", "max").from("breed_cost", "breedCost").from("breed_cost_table", "breedCostTable").noUnknown(!0), b = e.object({
  apostleSlotTable: e.array().of(f).default([]),
  reserveSlotTable: e.array().of(f).default([]),
  maxActiveSkill: e.number().default(3),
  maxAge: e.number().default(0),
  chronomergeCost: u
}).from("age_to_relic_apostle_slot", "apostleSlotTable").from("age_to_reserve_slot", "reserveSlotTable").from("max_active_skill", "maxActiveSkill").from("max_age", "maxAge").from("chronomerge_cost", "chronomergeCost").noUnknown(!0), g = e.object({
  assets: e.array().of(e.string()).default([])
}).from("related_asset", "assets"), C = e.lazy((t) => {
  const m = a.reduce(
    (d, l) => ({
      ...d,
      [l]: g
    }),
    {},
    a.keys(t)
  );
  return e.object(m);
}), h = e.object({
  maxManageCount: e.number().default(0),
  maxSelectedPlanet: e.number().default(0)
}).from("max_manage_count", "maxManageCount").from("max_selected_planet", "maxSelectedPlanet").noUnknown(!0), N = e.object({
  cooldown: e.number().default(0)
}).from("born_cooldown_in_second", "cooldown").noUnknown(!0), y = e.object({
  endTime: e.string().required().default(""),
  isMaintenance: e.boolean().default(!1),
  paths: e.array().of(e.string().required()).default([""])
}).camelCase().noUnknown(!0), k = e.object({
  cooldown: e.number().default(0),
  cooldownPlanet: e.number().default(0),
  fee: e.number().default(0),
  maxAttachEachTime: e.number().default(0),
  maxDuration: e.number().default(0),
  minDuration: e.number().default(0)
}).from("attach_planet_to_star_max", "maxAttachEachTime").from("planet_attach_cooldown", "cooldownPlanet").from("platform_fee", "fee").from("rental_cool_down_in_hr", "cooldown").from("rental_duration_max_in_day", "maxDuration").from("rental_duration_min_in_day", "minDuration"), S = e.object({
  assetNames: e.array().of(e.string()).default([])
}).from("claimable_asset_name", "assetNames"), T = e.object().shape({
  createOrderTypedDataErc1155: e.object().required(),
  createOrderTypedDataErc721: e.object().required()
}).transform((t) => ({
  createOrderTypedDataErc1155: JSON.parse(t.create_order_typed_data_erc1155) || {},
  createOrderTypedDataErc721: JSON.parse(t.create_order_typed_data_erc721) || {}
})).default({
  createOrderTypedDataErc1155: {},
  createOrderTypedDataErc721: {}
}), j = e.object({
  onToOffChain: e.array().of(
    e.object({
      off: e.string().required(),
      on: e.string().required(),
      ratio: e.number().required()
    })
  )
}).from("on_to_off_chain", "onToOffChain").default({
  onToOffChain: []
}), w = e.object({
  conversion: j
}).default({
  conversion: {
    onToOffChain: []
  }
}), A = e.object().shape({
  planetBreed: e.object()
}).from("planet_breed", "planetBreed").default({
  planetBreed: {}
}), x = e.object({
  currencyCode: r,
  minPrice: e.string().default("")
}).from("currency_code", "currencyCode").from("min_price", "minPrice"), v = e.object({
  postSetting: e.array().of(x).default([]),
  supportedCurrencies: e.array().of(r).default([])
}).from("post_setting", "postSetting").from("support_post_currency_code", "supportedCurrencies").noUnknown(!0), O = e.object({
  apostle: v
}).noUnknown(!0), c = e.object({
  onChain: e.array().of(e.string()).default([]),
  offChain: e.array().of(e.string()).default([])
}).from("on_chain", "onChain").from("off_chain", "offChain"), M = e.object({
  [o.AccountHeaderToken]: c,
  [o.AllToken]: c,
  [o.DailyCheckIn]: e.array().of(e.string()).default([]),
  [o.VipShop]: e.array().of(e.string()).default([]),
  [o.Unspecified]: e.array().of(e.string()).default([])
}).from("account_header_tokens", o.AccountHeaderToken).from("all_tokens", o.AllToken).from("daily_checkin", o.DailyCheckIn).from("vip_shop", o.VipShop), D = e.object({
  level: e.number().default(0),
  rate: e.array().of(e.string()).default([]),
  scaler: e.number().default(0)
}).from("monthly_scaler", "scaler"), P = e.object({
  duration: e.array().of(e.number()).default([]),
  data: e.array().of(D).default([])
}).from("table_data", "data"), R = e.object({
  aprTable: P,
  percentage: e.array().of(
    e.object({
      boostRatio: e.number().default(0),
      duration: e.number().default(0)
    }).from("boost_ratio", "boostRatio").from("duration_in_second", "duration")
  ),
  supportStakeTokens: e.array().of(
    e.object({
      currencyCode: n,
      opRatio: e.number().default(0)
    }).from("asset_name", "currencyCode").from("op_ratio", "opRatio")
  ),
  supportGetTokens: e.array().of(
    e.object({
      from: n,
      to: e.array().of(n).required()
    })
  ),
  levelChart: e.array().of(
    e.object({
      minOrderlyPoint: e.number().default(0)
    }).from("min_orderly_point", "minOrderlyPoint")
  )
}).from("apr_rating_table", "aprTable").from("level_chart", "levelChart").from("support_get_tokens", "supportGetTokens").from("support_stake_tokens", "supportStakeTokens").default({
  supportGetTokens: [],
  supportStakeTokens: []
}), B = e.object({
  apostleMerge: i,
  apostleMintConfig: e.array().of(e.object()).default([]),
  attach: p,
  bounty: O,
  breed: _,
  currency: w,
  discount: A,
  i18nLookup: e.object().shape({}).default({}),
  maintenance: e.array().of(y).default([]),
  managePlanetApostle: h,
  orbitRental: k,
  planet: b,
  relatedAsset: C,
  rewardCenter: S,
  roninMarketplace: T,
  supportToken: M,
  vipLevel: R
}).from("frontendConfig.apostle_merge", "apostleMerge").from("frontendConfig.attach", "attach").from("frontendConfig.bounty", "bounty").from("frontendConfig.breed", "breed").from("frontendConfig.currency", "currency").from("frontendConfig.discount", "discount").from("frontendConfig.i18n_lookup", "i18nLookup").from("frontendConfig.maintenance", "maintenance").from("frontendConfig.manage_planet_apostle", "managePlanetApostle").from("frontendConfig.rental_orbital_track", "orbitRental").from("frontendConfig.planet", "planet").from("frontendConfig.related_asset", "relatedAsset").from("frontendConfig.reward_center", "rewardCenter").from("frontendConfig.ronin_marketplace", "roninMarketplace").from("frontendConfig.support_token", "supportToken").from("frontendConfig.vip_level", "vipLevel").noUnknown(!0);
export {
  i as frontendApostleMergeConfigSchema,
  p as frontendAttachConfigSchema,
  N as frontendBornConfigSchema,
  O as frontendBountyConfigSchema,
  _ as frontendBreedConfigSchema,
  B as frontendConfigSchema,
  w as frontendCurrencyConfigSchema,
  j as frontendCurrencyConversionConfigSchema,
  y as frontendMaintenanceSchema,
  h as frontendManagePlanetApostleConfigSchema,
  k as frontendOrbitRentalConfigSchema,
  b as frontendPlanetConfigSchema,
  S as frontendRewardCenterConfigSchema,
  T as frontendRoninMarketplaceConfigSchema
};
//# sourceMappingURL=config.js.map
